<template>
  <template v-if="order">
    <HeadlessDisclosure #default="{ open: receiptIsOpen }">
      <Transition
        enter-active-class="transition-all duration-300 overflow-hidden"
        enter-from-class="transform scale-95 opacity-0 max-h-0"
        enter-to-class="transform scale-100 opacity-100 max-h-[1000px]"
        leave-active-class="transition-all duration-200 overflow-hidden"
        leave-from-class="transform max-h-[1000px]"
        leave-to-class="transform max-h-0"
      >
        <HeadlessDisclosurePanel>
          <div class="flex flex-col items-center pb-4 pt-6">
            <div class="w-full max-w-xs space-y-2">
              <ReceiptPreview
                :receipt-string="order.receiptString"
              />

              <div class="flex flex-col space-y-2">
                <FormSubmitButton
                  type="button"
                  class="col-span-2"
                  @click="onDownloadReceipt"
                >
                  Download Merchant Receipt
                </FormSubmitButton>
                <FormSubmitButton
                  type="button"
                  @click="emailModalIsOpen = true"
                >
                  Email Receipt
                </FormSubmitButton>
                <FormSubmitButton
                  v-if="
                    organizationConfig?.smsServiceEnabled
                  "
                  type="button"
                  @click="smsModalIsOpen = true"
                >
                  SMS Receipt
                </FormSubmitButton>
              </div>
            </div>
          </div>
        </HeadlessDisclosurePanel>
      </Transition>
      <HeadlessDisclosureButton
        :class="[
          'flex w-full items-center justify-center rounded-lg py-2',
          'hover:bg-background-fg/3',
        ]"
      >
        <template v-if="receiptIsOpen">
          <span> Hide Receipt </span>
          <IconChevronUp class="size-6" />
        </template>
        <template v-else>
          <span> Show Receipt </span>
          <IconChevronDown class="size-6" />
        </template>
      </HeadlessDisclosureButton>
    </HeadlessDisclosure>
  </template>
  <ReceiptEmailModal
    :is-open="emailModalIsOpen"
    :order-id="orderId"
    @close="emailModalIsOpen = false"
  />
  <ReceiptSmsModal
    :is-open="smsModalIsOpen"
    :order-id="orderId"
    @close="smsModalIsOpen = false"
  />
</template>

<script setup lang="ts">
const props = defineProps<{ orderId: string }>()
const { organizationConfig } = useOrganizationConfig()

const emailModalIsOpen = ref(false)
const smsModalIsOpen = ref(false)

const { data: order } = useOrder(props.orderId)

const onDownloadReceipt = () => {
  if (!order.value) return

  download(
    order.value.receiptString,
    `Order: #${order.value.orderNumber} receipt (merchant).txt`,
    "text/plain"
  )
}
</script>
